import { AppState } from '../store';

export interface LoadingSpinnerAction {
  type: 'SHOW' |  'HIDE';
}
export const SHOW_LOADER = 'SHOW';
export const HIDE_LOADER = 'HIDE';

export const showLoader = () => ({ type: SHOW_LOADER } as LoadingSpinnerAction);
export const hideLoader = () => ({ type: HIDE_LOADER } as LoadingSpinnerAction);

export const loaderSelector = ({ loadingSpinner }: AppState): boolean => {
  return loadingSpinner.loading;
};
